export default __webpack_public_path__ + "static/media/CFFundPasscodeImage.f5aecfaf.gif";